export default __webpack_public_path__ + "static/media/icon-bottom-arrow.8d0cae4e.svg";